export default __webpack_public_path__ + "static/media/sj.c2a3c34c.svg";